import { all, AllEffect } from 'redux-saga/effects';
import AppointmentReducer from './duck/reducer';
import { watchGetAllUsersAppointments } from './duck/saga';

function* AppointmentSaga(): Generator<AllEffect<Generator>> {
  yield all([watchGetAllUsersAppointments()]);
}

export { AppointmentReducer, AppointmentSaga };
